import { Form } from 'react-bootstrap';
import t from '../../../text';

export const EmailSignUp = ({ email, setEmail }) => (
  <Form.Group controlId="EmailAddress">
    <Form.Label className="text-white">{t('search.dealSignup')}</Form.Label>
    <Form.Control
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      type="email"
      placeholder="Email address"
      className="mt-md-0 toggle-popup"
    />
    <Form.Control.Feedback type="invalid">{t('footer.newsletter.invalidEmail')}</Form.Control.Feedback>
  </Form.Group>
);
